// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warpp {\n  padding-right: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
